/**
 * Lenis smooth scroll for the whole site, from hung-hola's assets/js/lenis.js (owner, 2026-10-19), set up like dmd.
 * - The instance is window.lenis. Code that scrolls the page itself hands the scroll to it:
 *   window.lenis.scrollTo(target, { duration, easing, force: true }) (portfolio auto-scroll). A window.scrollTo is taken
 *   back by the next Lenis frame.
 * - Lenis runs on the GSAP ticker and updates ScrollTrigger on every scroll, so scrubbed timelines follow the glide.
 * - In-page anchors (#contact-us, ...) glide with Lenis too.
 * - A scrolling area inside the page takes data-lenis-prevent; Easy Popup's overflow is prevented here.
 * - Touch keeps the native scroll (Lenis default).
 * - Nectar Blocks' own smooth scroll stays off (its global setting), or the two fight.
 * Off with ?still (screenshot compare) and prefers-reduced-motion: the page scrolls natively.
 */
import Lenis from 'lenis';
import { isStill } from './motion';

export function initLenis(): void {
	if (isStill()) {
		return;
	}
	const lenis = new Lenis({
		duration: 1,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		anchors: true,
		prevent: (node) => node.classList.contains('easy-popup-overflow'),
	});
	window.lenis = lenis;

	const { gsap, ScrollTrigger } = window;
	if (gsap && ScrollTrigger) {
		lenis.on('scroll', ScrollTrigger.update);
		gsap.ticker.add((time) => lenis.raf(time * 1000));
	} else {
		const raf = (time: number): void => {
			lenis.raf(time);
			requestAnimationFrame(raf);
		};
		requestAnimationFrame(raf);
	}
}
